import { render, staticRenderFns } from "./summaryColumn.vue?vue&type=template&id=c4c74f32"
import script from "./summaryColumn.vue?vue&type=script&lang=js"
export * from "./summaryColumn.vue?vue&type=script&lang=js"
import style0 from "./summaryColumn.vue?vue&type=style&index=0&id=c4c74f32&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports